<template>
  <div class="wx-biz-message-push-form-input">
    <el-input v-model="inputValue"
              show-word-limit
              v-bind="inputOpts"></el-input>
  </div>
</template>

<script>
export default {
  name: 'WxBizMessagePushFormInput',
  props: {
    value: String,
    rule: String
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    inputOpts () {
      switch (this.rule) {
        case 'thing': {
          return {
            maxlength: 20,
            placeholder: '可汉字、数字、字母或符号组合'
          }
        }
        case 'number': {
          return {
            maxlength: 32,
            placeholder: '只能数字，可带小数'
          }
        }
        case 'letter': {
          return {
            maxlength: 32,
            placeholder: '只能字母'
          }
        }
        case 'symbol': {
          return {
            maxlength: 5,
            placeholder: '只能符号'
          }
        }
        case 'character_string': {
          return {
            maxlength: 32,
            placeholder: '可数字、字母或符号组合'
          }
        }
        case 'time': {
          return {
            placeholder: '支持填时间段，两个时间点之间用“~”符号连接（例如：15:01，或：2019年10月1日 15:01）'
          }
        }
        case 'date': {
          return {
            placeholder: '支持填时间段，两个时间点之间用“~”符号连接（例如：2019年10月1日，或：2019年10月1日 15:01）'
          }
        }
        case 'amount': {
          return {
            placeholder: '1个币种符号+10位以内纯数字，可带小数，结尾可带“元”（可带小数）'
          }
        }
        case 'phone_number': {
          return {
            maxlength: 17,
            placeholder: '数字、符号（电话号码，例：+86-0766-66888866）'
          }
        }
        case 'car_number': {
          return {
            maxlength: 8,
            placeholder: '第一位与最后一位可为汉字，其余为字母或数字（车牌号码：粤A8Z888挂）'
          }
        }
        case 'name': {
          return {
            maxlength: 20,
            placeholder: '10个以内纯汉字或20个以内纯字母或符号'
          }
        }
        case 'phrase': {
          return {
            maxlength: 5,
            placeholder: '5个以内纯汉字，例如：配送中'
          }
        }
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss">
  .wx-biz-message-push-form-input {
    .el-input {
      width: 100%;
    }
  }
</style>
